
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/whatsapp-for-healthcare-ebook",
      function () {
        return require("private-next-pages/resources/whatsapp-for-healthcare-ebook.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/whatsapp-for-healthcare-ebook"])
      });
    }
  